import React from "react"
import { Button } from "@mui/material"
import { withTheme } from "@emotion/react"


function StepperBtnBack(props) {

    const theme = props.theme
    const style = {
        width: props.width, height: props.height,
        ...theme.button.primary, gap: '8px', ...theme.typography.button,
        padding: theme.button.padding.p16,
        background: 'none',
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: 'none',
        ':hover': {
            background: 'none',
            boxShadow: 'none'
        },
        ...props.sx,
        visibility: props.hide  ? 'hidden':'visible'
    }

    return (
            <Button onClick={props.handleClick} sx={style} variant="contained" >
                {props.text}
            </Button>
        
    )
}

export default withTheme(StepperBtnBack)